<template>
  <gauge :initial-data="chartData"></gauge>
</template>

<script>
import Gauge from '../../../charts/Gauge';
import Vue from "vue";
import moment from "moment";

export default {
  name: "ConversionGauge",
  methods: {
    fetchData() {
      console.log('Fetching Conversion count');

      this.loading = true;
      return Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Widget.php', {
        params: {
          a: 'conversion',
          token: 'dlBWlbFDgR5A0eearsSZBouOH9I9282I',
          params: {
            manufacturer: this.$store.getters.objAuthorize.manufacturer,
            date_from: this.$store.state.Dashboard.widgetConfig.dateRange.from.length !== 0 ? this.$store.state.Dashboard.widgetConfig.dateRange.from : moment().subtract(3, 'months').format('YYYY-MM-DD'), //this.dateRange.from,
            date_to: this.$store.state.Dashboard.widgetConfig.dateRange.to.length !== 0 ? this.$store.state.Dashboard.widgetConfig.dateRange.to : moment().endOf('day').format('YYYY-MM-DD'), //this.dateRange.to,
            metric: 'count',
            view: this.$store.state.Dashboard.widgetConfig.viewType,
            reporting_increment: this.$store.state.Dashboard.widgetConfig.periodType
          }
        }
      }).then((response) => {
        this.loading = false;
        const recordSet = JSON.parse(response.bodyText);
        this.tabTotals = recordSet.totals;
      }).catch((err) => {
        this.loading = false;
        console.log('An error occurred: ' + err.toString(), err);
      }).finally(() => {
        this.loading = false;
      });
    },
  },
  data() {
    return {
      tabTotals: {
        total: 0
      }
      // chartData: [
      //   ['Label', 'Value'],
      //   ['', 0]
      // ]
    }
  },
  props: ['bus'],
  computed: {
    chartData: function() {
      let percent = this.tabTotals.sales_total / this.tabTotals.total * 100;

      percent = !isNaN(percent) ? Math.ceil(percent) : 0;

      return [
        ['Label', 'Value'],
        ['Converted', {v: percent, f: percent + '%'}]
      ]
    }
  },
  created() {
    this.bus.$on('update-data', () => {
      this.fetchData();
    });

    this.$store.commit('setTheme', 'conversion');

    this.fetchData();
  },
  components: {Gauge}
}
</script>

<style scoped>

</style>
